import React from 'react'
import View from './view'

const CommunityExplore = ({ ...props }) => {
    return <View {...props} />
}

export default CommunityExplore
